<template lang="html">
  <div class="item_title">
    <span>&nbsp;</span>
    <h2>{{title}}</h2>
    <a href="javascript:;"  @click="sign_in" v-if="isShowBtn"><i>&#xe611;</i>签到</a>
  </div>
  
</template>

<script>
import Vue from 'vue'

export default {
  
  props: {
    title: {
      type: String,
      required: true
    },
    isShowBtn: {
      type: Boolean,
      required: false
    },
  },
}
</script>

<style lang="scss">
  .item_title{
    height: .3rem;
    padding: .1rem;
    line-height: .3rem;
    background: #fff;
    display: flex;
    span{
      display: inline-block;
      width: .03rem;
      height: 100%;
      background: #ee2a3a;
    }
    h2{
      padding-left: .1rem;
      font-size: .14rem;
      flex: 1;
    }
    a{
      width: .6rem;
      height: .3rem;
      background: #ee2a3a;
      border-radius: .04rem;
      text-align: center;
      color: #fff;
    }
  }
  
</style>



// WEBPACK FOOTER //
// src/components/ItemTitle/ItemTitle.vue